
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export const CharacterDetailLoading = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-blue/10 to-teedee-blue/10">
      <Navbar />
      
      <main className="py-8" role="main" aria-label="Loading character information">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="animate-pulse space-y-6" aria-label="Loading content">
            <div className="h-8 bg-gray-200 rounded w-1/3"></div>
            <div className="h-64 bg-gray-200 rounded"></div>
            <div className="space-y-3">
              <div className="h-4 bg-gray-200 rounded"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
